import { store } from "../../app/store";
import {
  beginGlobalLoading,
  endGlobalLoading,
  setProgress,
  clearProgress,
} from "../../features/ui/uiSlice";
import {
  openAlertSuccess,
  openAlertError,
  openAlertInfo,
  cancelTopModal,
} from "../../features/modal/modalSlice";
import type { ServiceAdapter } from "../core/apiFactory";
import { service } from "../utils/utils";
import { confirm } from "../confirmServices";

export const serviceAdapter: ServiceAdapter = async (cfg) =>
  service({
    url: cfg.url,
    method: cfg.method,
    queryParams: cfg.queryParams,
    body: cfg.body,
    headers: cfg.headers,
    requestConfig: cfg.requestConfig,
    responseConfig: cfg.responseConfig,
  });

export const reduxEnv = {
  store,
  actions: {
    beginGlobalLoading,
    endGlobalLoading,
    setProgress,
    clearProgress,
    cancelTopModal,
    openConfirm: confirm,
    openAlertSuccess: (title: string, subtitle?: string) =>
      store.dispatch(openAlertSuccess({ title, subtitle })),
    openAlertError: (title: string, subtitle?: string) =>
      store.dispatch(openAlertError({ title, subtitle })),
    openAlertInfo: (title: string, subtitle?: string) =>
      store.dispatch(openAlertInfo({ title, subtitle })),
  },
};
